import { store } from "./../../redux/";
import { call, put } from "redux-saga/effects";
import CONSTANTS from "./../../util/constants";
import { url } from "./../../services/Url";
import APICallingService from "./../../services/APICallingService";
import Encrypt from "../../util/encrypt";

const loginApi = (action) => {
  return APICallingService.sendRequestForPostWithAuth(
    url.login,
    action.payload.value,
    true,
    (res) => {},
    true
  );
};

//generator function
function* callLoginAPI(action) {
  try {
    let s = store.getState();
    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(loginApi, action);
    console.log("responseresponseresponse", response);
    if (
      response &&
      response?.callBackStatus.toLowerCase() == "success" &&
      response.data.statusCode != 400
    ) {
      let encrypt = Encrypt.encryptData(JSON.stringify(response.data));
      yield localStorage.setItem("L_R", encrypt);
      yield put({
        type: CONSTANTS.CONSTANTS_LOGIN.USER_LOGIN_SUCCEEDED,
        payload: { value: response.data },
      });
    } else if (response?.data?.statusCode == 400) {
      alert("Incorrect Username or Password");

      yield put({
        type: CONSTANTS.CONSTANTS_LOGIN.USER_LOGIN_SUCCEEDED,
        payload: { value: "Failed" },
      });
    } else {
      alert("Network Error ,Please try again Later");

      yield put({
        type: CONSTANTS.CONSTANTS_LOGIN.USER_LOGIN_SUCCEEDED,
        payload: { value: "Failed" },
      });
    }

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: false },
    });
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.USER_LOGIN_FAILED,
      payload: { value: "Failed" },
    });
    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: false },
    });
  }
}
function* updateLoginAPI(response) {
  try {
    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.USER_LOGIN_SUCCEEDED,
      payload: { value: response.payload.value },
    });
    console.log("updateLoginAPI", response.payload.value);
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.USER_LOGIN_FAILED,
      payload: { value: "Failed" },
    });
    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: false },
    });
  }
}

const getDivisionStats = () => {
  return APICallingService.sendRequestForGet(
    url.getDivisionStats,
    (res) => {},
    true
  );
};

function* callGetDivisionStats() {
  try {
    let s = store.getState();
    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });
    const response = yield call(getDivisionStats);
    if (response && response?.callBackStatus.toLowerCase() == "success") {
      yield put({
        type: CONSTANTS.CONSTANTS_LOGIN.GET_USER_DIVISION_STATS_RESPONSE,
        payload: { value: response.data },
      });
    } else {
      alert("No data available");
      yield put({
        type: CONSTANTS.CONSTANTS_LOGIN.GET_USER_DIVISION_STATS_RESPONSE,
        payload: { value: response?.callBackStatus },
      });
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.GET_USER_DIVISION_STATS_RESPONSE,
      payload: { value: "Failed" },
    });
  }
}

const forgotPasswordnApi = (action) => {
  return APICallingService.sendRequestForPostWithAuth(
    url.forgotpassword,
    action.payload.value,
    true,
    (res) => {},
    true
  );
};

//generator function
function* callForgotPasswordAPI(action) {
  try {
    let s = store.getState();
    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(forgotPasswordnApi, action);
    if (
      response &&
      response?.callBackStatus.toLowerCase() == "success" &&
      response.data.statusCode != 400
    ) {
      alert("Security Code Sent Successfully , Please check Email");
      yield put({
        type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_FORGOT_PASSWORD_API_RESPONSE,
        payload: { value: response.data },
      });
    } else {
      alert("Failed to send code ,Please try again");
    }

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: false },
    });
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: false },
    });
  }
}

const confirmPasswordnApi = (action) => {
  return APICallingService.sendRequestForPostWithAuth(
    url.confirmpassword,
    action.payload.value,
    true,
    (res) => {},
    true
  );
};

//generator function
function* callConfirmPasswordAPI(action) {
  try {
    let s = store.getState();
    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(confirmPasswordnApi, action);
    if (
      response &&
      response?.callBackStatus.toLowerCase() == "success" &&
      response.data.statusCode != 400
    ) {
      alert("Password Updated Successfully");
      yield put({
        type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_CONFIRM_PASSWORD_API_RESPONSE,
        payload: { value: response.data },
      });
    } else {
      alert("Failed to get data,Please try again");
    }

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: false },
    });
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: false },
    });
  }
}

export {
  callLoginAPI,
  updateLoginAPI,
  callGetDivisionStats,
  callForgotPasswordAPI,
  callConfirmPasswordAPI,
};
